export default __webpack_public_path__ + "d28f0e10b38ec254b914922b2b85831b.svg";